const LOGOS = [
  { name: "Hexabase", mark: "M12 2l9 5v10l-9 5-9-5V7l9-5z" },
  { name: "Promptline", mark: "M4 17l6-6-6-6M12 19h8" },
  { name: "Vectordash", mark: "M3 12h18M3 6h18M3 18h12" },
  { name: "Kernelhub", mark: "M12 3v18M3 12h18M5.6 5.6l12.8 12.8M18.4 5.6L5.6 18.4" },
  { name: "Stackforge", mark: "M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" },
  { name: "Codebloom", mark: "M12 2a7 7 0 017 7c0 2-1 3.5-2 4.5S16 16 16 18H8c0-2-.5-3-1-4.5S5 11 5 9a7 7 0 017-7z" },
];

export const LogoStrip = () => {
  return (
    <section
      data-testid="logo-strip"
      className="max-w-6xl mx-auto px-6 py-14 border-b border-seam"
    >
      <p className="text-center text-[11px] uppercase tracking-widest text-smoke mb-8">
        Powering lean agent stacks at
      </p>
      <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-6">
        {LOGOS.map((logo) => (
          <div
            key={logo.name}
            data-testid={`client-logo-${logo.name.toLowerCase()}`}
            className="flex items-center gap-2 text-smoke/70 hover:text-ash transition-colors"
          >
            <svg
              className="w-5 h-5"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d={logo.mark} />
            </svg>
            <span className="text-sm font-semibold tracking-wide">
              {logo.name}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};
